
import { gsap } from "gsap"

const SVGRoundedButtons = (container) => {
    let svgRoundedButtons = [...container.querySelectorAll('.svg-rounded-button')]
    // console.log(svgRoundedButtons)
    svgRoundedButtons.forEach( svgRoundedButton => {
        let btn = svgRoundedButton.querySelector('.button--border')
        let width = Math.round(btn.getBoundingClientRect().width)
        let height = Math.round(btn.getBoundingClientRect().height)
        let start = 40
        let svgWrappers = [...btn.querySelectorAll('.svg-wrapper')]
        let length = 0
        svgWrappers.forEach( wrapper => {
            let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            let path = document.createElementNS("http://www.w3.org/2000/svg", 'path');
            svg.appendChild(path)
            svg.setAttribute('width', width)
            svg.setAttribute('height', height)
            svg.setAttribute('viewBox', '0 0 ' + width + ' ' + height + '');
            path.setAttribute('d', 'M ' + start + ' ' + height/8 + ' H ' + (width-40) +
            ' C ' + width + ' ' + height/8 + ' ' + width + ' ' + height*7/8 + ' ' + (width-40) + ' ' + height*7/8 +
            ' H ' + start +
            ' C 0 ' + height*7/8  + ' 0 ' + height/8 + ' ' + start + ' ' + height/8 + ' Z')
            length = Math.round(path.getTotalLength())
            wrapper.appendChild(svg)
            wrapper.classList.contains('svg-wrapper--thin') ? wrapper.querySelector('svg').classList.add('thin') : wrapper.querySelector('svg').classList.add('progress')
            // if wrapper.classList.contains('svg-wrapper--thin') wrapper.querySelector('path').classList.add('js-header-stroke')
            wrapper.querySelector('svg path').style.strokeDasharray = length + ' ' + length
            if(wrapper.classList.contains('svg-wrapper--thin')){
                wrapper.querySelector('svg path').style.strokeDashoffset = 0
                if(svgRoundedButton.closest('header') !== null){
                    wrapper.querySelector('path').classList.add('js-header-stroke')
                }
            }
            else{
                wrapper.querySelector('svg path').style.strokeDashoffset = length
            }

        })
        svgRoundedButton.addEventListener('mouseenter', () => {
            if(svgRoundedButton.classList.contains('is-waiting')) return
            gsap.to(btn.querySelector('.progress path'), {duration: 0.6, strokeDashoffset: 0, ease: 'power2.inOut'})
        })
        svgRoundedButton.addEventListener('mouseleave', () => {
            // if(btn.classList.contains('active')) return
            gsap.to(btn.querySelector('.progress path'), {duration: 0.6, strokeDashoffset: length, ease: 'power2.inOut'})
        })
    })
}


export {SVGRoundedButtons}
